<template>
	<div>
		<h1>Szobapontozás {{new Date().toISOString().substring(0,10)}}</h1>
		<v-data-table
			:items="adatok.szobak"
			:headers="tablazatok.szobapontozas.fejlec"
			sort-by="szobanev"
			v-if="nemhetvege(new Date().toISOString().substring(0,10))"
		>
			<template v-slot:item.szobalakoi="{item}">
				<v-tooltip top :key="lako.id" v-for="lako in adatok.felhasznalok.filter(f => f.szobaid==item.id)">
					<template v-slot:activator="{on, attrs}">
						<v-chip color="success" v-bind="attrs" v-on="on">{{lako.nev}}</v-chip>
					</template>
					{{(lako.csoportid? adatok.csoportok.find(cs => cs.id==lako.csoportid).csoportnev+" (Csoportvezető: "+adatok.felhasznalok.find(f => f.id==adatok.csoportok.find(cs =>cs.id==lako.csoportid).csoportvezetoid).nev+") - ": "")+adatok.minositesek.find(m =>m.id==lako.minosites).minositesnev}}
				</v-tooltip>
			</template>
			<template v-slot:item.pontok="{item}">
				<v-chip color="success">Összeg: {{osszeg(item.id)}}</v-chip>
				<v-tooltip top :key="pont.pontozasiszempontid" v-for="pont in adatok.szobapontozas.filter(p => p.szobaid==item.id&&p.nap==new Date().toISOString().substring(0,10)).map(p => {
					return {
						...p,
						...adatok.szobapontozasiszempontok.find(sz => sz.id==p.pontozasiszempontid),
						nevelo: adatok.felhasznalok.find(f => f.id==p.neveloid).nev
					}
					})">
					<template v-slot:activator="{on, attrs}">
						<v-chip v-bind="attrs" v-on="on" color="primary" :close="pont.neveloid==$store.state.id||$store.state.minosites==-2" @click:close="ponttorlese(pont.szobaid,pont.pontozasiszempontid)">{{pont.szempont}}: {{pont.pont}}</v-chip>
					</template>
					{{pont.leiras}} - {{pont.nevelo}}
				</v-tooltip>
			</template>
			<template v-slot:item.uj="{item}">
				<v-tooltip top>
					<template v-slot:activator="{on, attrs}"><v-btn  v-on="on" v-bind="attrs" icon color="primary" @click="dialogusok.ujszobapont.szoba={...item}, dialogusok.ujszobapont.mutat=true"><v-icon>fa-plus</v-icon></v-btn></template>
					Új
				</v-tooltip>
			</template>
		</v-data-table>
		<span v-else>Jó hétvégét! ☺</span>
		<v-dialog
				v-model="dialogusok.ujszobapont.mutat"
				persistent
				max-width="600px"
		>

				<v-card>
					<v-card-title>
						<span class="headline" v-if="dialogusok.ujszobapont.mutat">{{dialogusok.ujszobapont.szoba.szobanev}} szoba</span>
					</v-card-title>
					<v-card-text>
						<v-container>

							<v-select
								prepend-inner-icon="fa-broom"
								label="Szempont"
								:items="adatok.szobapontozasiszempontok.filter(szpsz => adatok.szobapontozas.findIndex(szp => szp.szobaid==dialogusok.ujszobapont.szoba.id&&szp.pontozasiszempontid==szpsz.id)==-1)"
								v-model="dialogusok.ujszobapont.szempont"
								item-value="id"
								item-text="szempont"
								v-if="adatok.szobapontozasiszempontok"
							>
								<template v-slot:item="{item}">
									<v-tooltip top>
										<template v-slot:activator="{on,attrs}">
											<v-span v-bind="attrs" v-on="on">{{item.szempont}}: {{item.pont}}</v-span>
										</template>
										{{item.leiras}}
									</v-tooltip>
								</template>
							</v-select>

						</v-container>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							color="blue darken-1"
							text
							@click="dialogusok.ujszobapont.mutat=false"
						>
							Mégsem<v-icon>fa-times</v-icon>
						</v-btn>
						<v-btn
							color="success"
							text
							v-if="dialogusok.ujszobapont.szempont>-1"
							@click="ujszobapont"
						>
							Hozzáadás<v-icon>fa-plus</v-icon>
						</v-btn>
					</v-card-actions>
				</v-card>
		</v-dialog>
		<v-snackbar
		 v-model="snackbar.megnyit"
		>
		 {{ snackbar.szoveg }}
		 <v-btn
			 color="pink"
			 text
			 @click="snackbar.megnyit = false"
		 >
			 Bezár
		 </v-btn>
		</v-snackbar>
	</div>
</template>

<script>
	import router from '../router';
	export default {
		data: function(){
			return {
        snackbar: {
          megnyit: false,
          szoveg: ""
        },
        tablazatok: {
					szobapontozas: {
						fejlec: [
							{
								text: "Szoba",
								value: "szobanev",
								align: "center",
								groupable: false,
								sortable: true,
								filterable: false
							},
							{
								text: "Szoba lakói",
								value: "szobalakoi",
								align: "center",
								groupable: false,
								sortable: false,
								filterable: false
							},
							{
								text: "Pontok",
								value: "pontok",
								align: "center",
								groupable: false,
								sortable: false,
								filterable: false
							},
							{
								text: "Új",
								value: "uj",
								align: "center",
								groupable: false,
								sortable: false,
								filterable: false
							}
						]
					}
        },
        dialogusok: {
					ujszobapont: {
						mutat: false,
						szoba: {},
						szempont: -1
					}
        },
        adatok: {}
      }
		},
		computed: {

		},
		watch: {

		},
		methods: {
			ponttorlese: function(szobaid,pontozasiszempontid){
				this.axios.delete(this.$store.state.backendeleres+"szobapontozas/ponttorlese/"+new Date().toISOString().substring(0,10)+"/"+szobaid+"/"+pontozasiszempontid)
									.then((response) => {
										if(response.data.bejelentkezve==false) this.kijelentkezes();
										if(response.data.ok) {
											this.adatok.szobapontozas.splice(this.adatok.szobapontozas.findIndex(szp => szp.szobaid==szobaid&&szp.pontozasiszempontid==pontozasiszempontid),1);
											this.snackbar.szoveg="A törlés sikeresen megtörtént";
											this.snackbar.mutat=true;
										}
										else{
											this.snackbar.szoveg="A törlés hibába ütközött: "+response.data.hiba;
											this.snackbar.mutat=true;
										}
									})
			},
			ujszobapont: function() {
				this.axios.post(this.$store.state.backendeleres+"szobapontozas/ujszobapont",{szobaid: this.dialogusok.ujszobapont.szoba.id, pontozasiszempontid: this.dialogusok.ujszobapont.szempont, nap: new Date().toISOString().substring(0,10)})
									.then((response) => {
										if(response.data.bejelentkezve==false)this.kijelentkezes();
										if(response.data.ok) {
											this.adatok.szobapontozas.push({szobaid: this.dialogusok.ujszobapont.szoba.id, pontozasiszempontid: this.dialogusok.ujszobapont.szempont, neveloid: this.$store.state.id, nap: new Date().toISOString().substring(0,10)})
											this.snackbar.szoveg="A pontozás sikeresen megtörtént";
											this.snackbar.mutat=true;
											//this.dialogusok.ujszobapont.mutat=false
											this.dialogusok.ujszobapont.szempont=-1
										}
										else{
											this.snackbar.szoveg="A pontozás hibába ütközött: "+response.data.hiba;
											this.snackbar.mutat=true;
										}
									})
			},
			nemhetvege: nap => new Date(Date.parse(nap)).getDay()<6&&new Date(Date.parse(nap)).getDay()>0,
			osszeg: function(szoba) {
				var osszeg =this.adatok.alapszobapont;
				this.adatok.szobapontozas.filter(p => p.nap==new Date().toISOString().substring(0,10)&&p.szobaid==szoba).forEach(p => {
					osszeg+=this.adatok.szobapontozasiszempontok.find(szp => szp.id==p.pontozasiszempontid).pont
				})
				return osszeg;
			}

		},
		mounted(){
			this.axios.get(this.$store.state.backendeleres+"szobapontozas/"+new Date().toISOString().substring(0,10)+"/"+new Date().toISOString().substring(0,10)).then((response) => {
				if(response.data.ok){
          this.adatok=response.data.adatok;
				}
        if(response.data.bejelentkezve== false) this.kijelentkezes();
			})
		}
	}
</script>
